import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output, computed, inject } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { SearchResultUiService } from '../../../services/search-result-ui.service';
import { SearchBoxService } from '@shared/services/serach-box.service';

@Component({
  selector: 'iho-sort-filter',
  templateUrl: './sort-filter.component.html',
  styleUrls: ['./sort-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SharedModule,
    MatListModule
  ]
})
export class SortFilterComponent implements OnInit {
  setParams: any;
  private searchBoxService = inject(SearchBoxService);
  @Output() selectedItemSort = new EventEmitter();
  @Output() closeBottomSheet = new EventEmitter();
  route = inject(ActivatedRoute);
  router = inject(Router);
  searchUiService = inject(SearchResultUiService);
  accommodation = computed(() => this.searchBoxService.accommodation());

  checklist = [
    { id: 1, value: 'پیشنهاد ما', isSelected: true, enVal: 'bestmatch' },
    { id: 2, value: 'کمترین قیمت', isSelected: false, enVal: 'minprice' },
    { id: 3, value: 'درجه هتل (نزولی)', isSelected: false, enVal: 'gradedesc' },
    { id: 4, value: 'درجه هتل (صعودی)', isSelected: false, enVal: 'gradeasc' },
    { id: 5, value: 'بهترین نظر', isSelected: false, enVal: 'bestreview' },
    { id: 6, value: 'بهترین نظر و قیمت', isSelected: false, enVal: 'bestreviewminprice' },

  ];
  checklistEcologe = [
    { id: 1, value: 'پیشنهاد ما', isSelected: true, enVal: 'bestmatch' },
     { id: 2, value: 'ارزانترین', isSelected: false, enVal: 'minprice' },
    // { id: 3, value: 'گرانترین', isSelected: false, enVal: 'maxprice' },

  ];
  ngOnInit(): void {
    let params: any = this.route.snapshot.queryParams;
    if (params.sort && this.accommodation() != 'ecolodge') {
      this.checklist.forEach(item => {
        if (item.enVal == params.sort) {
          item.isSelected = true

        } else {
          item.isSelected = false

        }
      })
    } else if(params.sort && this.accommodation() == 'ecolodge') {
      this.checklistEcologe.forEach(item => {
        if (item.enVal == params.sort) {
          item.isSelected = true

        } else {
          item.isSelected = false

        }
      })
    }
  }
checkedItem(isSelectId: number,type:string) {
  if (type == 'ecolodge') {
    this.checklistEcologe.forEach(item => {
      if (item.id == isSelectId) {
        item.isSelected = true;
      }
      else {
        item.isSelected = false;

      }
    })
    this.selectedItemSort.emit(this.checklistEcologe.filter(item => item.id == isSelectId)[0]);

  } else {
    this.checklist.forEach(item => {
      if (item.id == isSelectId) {
        item.isSelected = true;
      }
      else {
        item.isSelected = false;

      }
    })
    this.selectedItemSort.emit(this.checklist.filter(item => item.id == isSelectId)[0])
  }
    
    this.searchUiService.resetPlpResults()

    this.searchUiService.isFilterSet.update((_) => _ + 1)
  
    this.closeBottomSheet.emit(false)
  }

  closeSort() {
    this.closeBottomSheet.emit(false)
  }

}
